import Button from 'lib/ui/Button'
import React from 'react'
import styled from 'styled-components'

export default function TestWebhookButton(props: {onClick: () => void}) {
  return (
    <StyledButton variant="outlined" color="primary" onClick={props.onClick}>
      Test webhook
    </StyledButton>
  )
}

const StyledButton = styled(Button)`
  height: 40px;
  margin-bottom: 22px;
`
